import styles from './Card.module.css'

const Card = ({ children, variant }) => {
  const variantStyle =
    variant === 'empty' ? styles.empty : styles.content

  return (
    <div className={`${styles.card} ${variantStyle}`}>
      {children}
    </div>
  )
}
export default Card
